import {createRouter, createWebHashHistory} from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'indexEn',
        component: () => import('../views/indexEn.vue')
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
